import "../css/connections.css";
import "../css/button.css";
import commoncss from "../css/common.module.css";
import buttoncss from "../css/button.module.css";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Table from "../elements/Table";
import {Button} from "../elements/Button";
import Modal from "../elements/Modal";
import StatusIndicator from "../elements/StatusIndicator";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import fscp_posting_logs from "../data/fscp_posting_logs.json";
import DefaultUser from "../assets/imgs/default_user.png";
import User2 from "../assets/imgs/user2.png";
import Dropdown from "./../elements/Dropdown";
import InputGroup from "./../elements/InputGroup";
import Breadcrumb from "./../components/Breadcrumb";

export default function FscpPostingLogs() {

  const [displayModal, setDisplayModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);


  const breadcrumbItems = [
    {
      label: "Workspace name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Book Closure name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "View FSCP Posting", link: "", className: "headerLable" },
    { label: "View Logs", link: "", className: "headerLable" },
  ];

  const th_data = [
    { header: "S.NO", accessor: "s_no" },
    { header: "PACKAGE NAME", accessor: "package_name" },
    { header: "DATE", accessor: "date" },
    { header: "TIME", accessor: "time" },
    { header: "USERNAME", accessor: "username" },
    { header: "STATUS", accessor: "status" },
  ];

  const tr_data = fscp_posting_logs.map((item, i) => ({
    s_no: i + 1,
    package_name: item.package_name,
    date: item.date,
    time: item.time,
    username: (
      <>
        <img className="card-user-img vaMiddle" src={User2} alt="user_image" />
        &nbsp;Jane Doe
      </>
    ),
    status:
      item.status === "F" ? (
        <span style={{display: "inline-flex"}}><StatusIndicator status="Failed" /> &ensp;Repush</span>
      ) :  (
        <StatusIndicator status="successfull" />
      ),
  }));

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <>
      <div className="connections-wrapper">
        <Breadcrumb
          items={breadcrumbItems}
          headerActions={
            <>
              <SearchIcon />&ensp;&nbsp;
              <FilterIcon
                className="clickable-icon mr-15"
                onClick={() => {
                  setFilterModal(true);
                  setDisplayModal(true);
                }}
                height={20}
              />
            </>
          }
        />
        <div className="connections-content info-content">
          <main>
            <Table columns={th_data} data={tr_data} />
            {/* <PaginationFooter /> */}
          </main>
        </div>
      </div>
      {filterModal && displayModal && (
        <Modal
          title="Filters"
          headerActions={
            <lable className="primaryLable clickable">Reset Filters</lable>
          }
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  handleClose();
                  setFilterModal(false);
                }}
                label="Cancel"
              />
              <span>
                <Button btnColor={buttoncss.secondary} label="Custom Filter" />
                &ensp;
                <Button btnColor={buttoncss.primary} label="Apply Filter" />
              </span>
            </>
          }
          onClose={() => console.log("Modal Closed")}
        >
          <InputGroup
            inputs={[
              <>
                <Dropdown
                  label="Ledger Code"
                  options={["TB001", "GL002"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Code"}
                />
              </>,
              <>
                <Dropdown
                  label="Ledger Name"
                  options={["Trial Balance", "General Ledger"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Name"}
                />
              </>,
            ]}
          />

          <Dropdown
            label="Preparer"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Preparer"}
          />

          <Dropdown
            label="Approver"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Approver"}
          />
        </Modal>
      )}
    </>
  );
}
